module.exports = __webpack_public_path__ + "img/logo_header.7e207cfd.png";